import { render, staticRenderFns } from "./endorseDtlsModal.vue?vue&type=template&id=7c23d008&scoped=true&"
import script from "./endorseDtlsModal.vue?vue&type=script&lang=js&"
export * from "./endorseDtlsModal.vue?vue&type=script&lang=js&"
import style0 from "./endorseDtlsModal.vue?vue&type=style&index=0&id=7c23d008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23d008",
  null
  
)

export default component.exports